import React from "react";
import { Formik, Form } from "formik";
import Model from "../../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn } from "../../Styles/InputStyles";

const DeleteTenantModal = ({
    setIsDeleteTenantModal,
    selectedData,
    deleteTenantLoading,
    deleteTenantMutate,
    e
}) => {


    const handleDeleteSubmit = () => {
        deleteTenantMutate({
            tenantId: selectedData?.data?.id,
            isEvicted: e ? true : false
        });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteTenantModal}
            title="Tenant Delete Confirmation"
        >
            <WarningText>
                This action will permanently delete the tenant and all associated data. This cannot be undone.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteTenantModal(false)}
                >
                    Cancel
                </SideCancelBtn>
                <SubmitBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteTenantLoading}
                    className="border border-rose-500 bg-white text-rose-500 hover:bg-rose-500 hover:text-white"
                >
                    {deleteTenantLoading ? "Loading..." : "Delete Tenant"}
                </SubmitBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteTenantModal;
